module.exports = __webpack_public_path__ + "img/rmb.2e9c88df.svg";